import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import AumHouseholdViewButton from './AumHouseholdViewButton';

const AumHouseholdViewPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.aumHouseholdView.name]: () => {
      return (
        <AumHouseholdViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AumHouseholdViewPicker;
